"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    formControl: {
      width: '152.5px',
      height: '44px',
      backgroundColor: '#F7F7F7',
      margin: 1,
      borderRadius: '10px',
      '& .MuiInputLabel-filled': {
        color: '#949494',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '5.5px'
      },
      '& .MuiInputBase-root': {
        '& .MuiSelect-root': {
          minHeight: '50px',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          fontWeight: typography.fontWeightRegular,
          fontSize: '14px',
          borderRadius: '10px',
          backgroundColor: '#f7f7f7',
          paddingLeft: '10px'
        }
      }
    },
    placeholder: {
      '& .MuiSelect-root': {
        color: '#b5b5b5'
      }
    }
  };
}, {
  name: 'DropDown'
});
exports.useStyles = useStyles;